import { render, staticRenderFns } from "./AppealSummary.vue?vue&type=template&id=38876951"
import script from "./AppealSummary.vue?vue&type=script&lang=js"
export * from "./AppealSummary.vue?vue&type=script&lang=js"
import style0 from "./AppealSummary.vue?vue&type=style&index=0&id=38876951&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports